module.exports = __webpack_public_path__ + "img/txaqicon.62937f69.svg";